export default __webpack_public_path__ + "static/media/depositephotos_.5755ab55.png";